import React, { useState, useEffect } from 'react';
import { Button, Checkbox, Form, Input, Alert, Spin, Image } from 'antd';
import logo from "../img/logo.png";
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { BACKEND_URL } from '../Backend';

const cookies = new Cookies();

function Login() {
  const navigate = useNavigate();
  const [backendError, setBackendError] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);

  useEffect(() => {
    cookies.remove('nivel'); // Limpia cookies al cargar Login
  }, []);

  const enviarDatos = (credentialResponse) => {
    setCargando(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({ token: credentialResponse.credential });

    fetch(`${BACKEND_URL}/login/`, {
      method: 'POST',
      headers: myHeaders,
      body: raw,
    })
      .then(response => {
        if (!response.ok) throw new Error('Usuario no encontrado');
        return response.json();
      })
      .then(result => {
        if (result.message === 'Login exitoso' && result.persona) {
          cookies.set('nivel', result.persona.nivel, { path: '/' });
          cookies.set('correo', result.persona.correo, { path: '/' });
          cookies.set('credencial', credentialResponse.credential, { path: '/' });

          // console.log("Nivel recibido:", result.persona.nivel);

          if (Number(result.persona.nivel) === 4) {
            navigate('/inicio');
          }
          else {
            navigate('/'); // O a otra ruta si se requiere
          }
        } else {
          alert('Usuario no encontrado');
        }
      })
      .catch(error => {
        console.log('Error:', error);
        setBackendError(true);
      })
      .finally(() => setCargando(false));
  };

  return (
    <div>
      <br />
      <Form
        name="basic"
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 16 }}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 600,
          border: '1px solid black',
          background: 'white',
          padding: '80px',
        }}
        initialValues={{ remember: true }}
        autoComplete="off"
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ display: 'flex', alignSelf: 'center' }}>
            <Image width={70} height={70} src={logo} />
          </div>
          <br /><br />

          {backendError && <Alert message="¡Ocurrió un error inesperado, por favor intenta más tarde!" type="error" />}
          
          <Spin spinning={cargando}>
            <GoogleLogin
              onSuccess={credentialResponse => {
                enviarDatos(credentialResponse);
              }}
              onError={() => {
                console.log('Login Failed');
              }}
            />
          </Spin>
        </div>
      </Form>
    </div>
  );
}

export default Login;
